export default {
  getPreviewCoursewareInfo: '/Courseware/previewCoursewareInfo', // 获取预览课件内容
  checkAnswer: '/Courseware/previewCheckTestAnswer', // 课件预览校验答案
  createCourseware: '/Courseware/saveAddCourseware', // 新建课件
  getCoursewareList: '/Courseware/coursewareList', // 获取课件列表
  freezeCourseware: '/Courseware/freezeCourseware', // 冻结课件
  getOperationLog: 'Courseware/operationList', // 获取操作日志
  publishOrVerify: '/Courseware/publishOrVerify', // 提审或者发布为初稿
  auditCourseware: '/Courseware/auditCourseware', // 定稿、驳回课件
  copyCourseware: '/Courseware/copyCourseware', // 复制课件
  getCoursewareInfo: '/Courseware/getCoursewareInfo', // 获取课件详细信息
  createOnlie: '/Courseware/addNewPageFromTiku', // 在线生成
  editCourseware: '/Courseware/saveEditCourseware', // 编辑课件
  getCommonPackage: 'Courseware/getCommonPackage', // 获取课件可进行属性编辑的页面包
  savePackageAttr: '/Package/savePackageAttr', // 保存属性编辑
  copyPakcage: '/Package/copyPackage', // 复制页面包
  addTest: '/Courseware/addNewTestPageToPackageFromTiku', // 像页面包添加试题
  copyPage: '/Page/copyPage', // 复制一个页面
  editPage: '/Page/saveEditPage', // 更改一个页面信息
  submitType: '/Page/saveSubmitType', // 保存页面课清信息
  savePackage: '/Package/saveEditPackage', // 编辑保存页面包
  savePageSort: '/Package/savePageOrder', // 保存页面包下页面的顺序
  savePackageSort: '/Courseware/savePackageOrder', // 保存课件下页面包的顺序
  addLiveResource: '/LiveResource/addLiveResource', // 添加直播资源
  setPageHeight: '/Page/saveEditPage', // 设置页面高度
  getCollaborationList: '/Cooperator/cooperatorList', // 获取协作列表
  addCooperator: '/Cooperator/addCooperator', // 添加协作者
  delCooperator: '/Cooperator/delCooperator', // 删除协作者
  searchUsers: '/Cooperator/searchUsers', // 通过真实姓名搜索用户
  getSwitchList: '/OperationSwitchH5/getSwitchList', // 获取H5课件生成未来课件列表
  switchH5: '/OperationSwitchH5/switchH5', // 复制H5课件生成未来课件
  searchPageList: '/TemplateStatistic/searchPageList', //页面搜索列表
  previewPage: '/TemplateStatistic/previewPage' //页面预览接口
}



// WEBPACK FOOTER //
// ./src/api/courseware.js